module.exports = __webpack_public_path__ + "img/thumb_17.37adbc82.png";